// packages/web/src/lib/feature-flags.ts
export interface FeatureFlag {
  enabled: boolean;
  rolloutPercentage: number;
  userWhitelist?: string[];
  tenantWhitelist?: string[];
}

class FeatureFlagService {
  private flags: Map<string, FeatureFlag> = new Map();

  constructor() {
    // Initialize with default flags for multi-user system
    this.flags.set('multi-user-navigation', {
      enabled: true,
      rolloutPercentage: 100
    });

    this.flags.set('customer-cart-tab', {
      enabled: true,
      rolloutPercentage: 100
    });

    this.flags.set('customer-orders-tab', {
      enabled: false,
      rolloutPercentage: 0
    });

    this.flags.set('customer-profile-tab', {
      enabled: false,
      rolloutPercentage: 0
    });

    this.flags.set('partner-commission-tab', {
      enabled: false,
      rolloutPercentage: 0
    });

    this.flags.set('partner-services-tab', {
      enabled: false,
      rolloutPercentage: 0
    });

    this.flags.set('partner-settings-tab', {
      enabled: false,
      rolloutPercentage: 0
    });

    this.flags.set('admin-users-tab', {
      enabled: false,
      rolloutPercentage: 0
    });

    this.flags.set('admin-tenants-tab', {
      enabled: false,
      rolloutPercentage: 0
    });

    this.flags.set('admin-monitoring-tab', {
      enabled: false,
      rolloutPercentage: 0
    });
  }

  isEnabled(flagName: string, userId?: string, tenantId?: string): boolean {
    const flag = this.flags.get(flagName);
    if (!flag) return false;

    // Check user whitelist
    if (flag.userWhitelist && userId && flag.userWhitelist.includes(userId)) {
      return true;
    }

    // Check tenant whitelist
    if (flag.tenantWhitelist && tenantId && flag.tenantWhitelist.includes(tenantId)) {
      return true;
    }

    // Check rollout percentage (for gradual rollout)
    if (flag.rolloutPercentage > 0) {
      const hash = this.simpleHash(userId || 'anonymous');
      const percentage = (hash % 100) + 1;
      return percentage <= flag.rolloutPercentage;
    }

    return flag.enabled;
  }

  private simpleHash(str: string): number {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash; // Convert to 32-bit integer
    }
    return Math.abs(hash);
  }

  updateFlag(flagName: string, updates: Partial<FeatureFlag>): void {
    const existing = this.flags.get(flagName);
    if (existing) {
      this.flags.set(flagName, { ...existing, ...updates });
    }
  }
}

export const featureFlags = new FeatureFlagService();